/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import * as moment from 'moment';

(moment as any).suppressDeprecationWarnings = true;

export const isNil = (value: any): boolean => value === undefined || value === null;

export const dateInRange = (
	value: any,
	{ start, end, granularity, canMatch }: { start?: any; end?: any; granularity?: moment.unitOfTime.StartOf; canMatch?: boolean }
): boolean => {
	if ((start || end) && !value) {
		return false;
	}
	let result = true;

	if (value) {
		if (start) {
			if (canMatch) {
				result &&= moment.utc(value).isSameOrAfter(moment.utc(start), granularity);
			} else {
				result &&= moment.utc(value).isAfter(moment.utc(start), granularity);
			}
		}

		if (end) {
			if (canMatch) {
				result &&= moment.utc(value).isSameOrBefore(moment.utc(end), granularity);
			} else {
				result &&= moment.utc(value).isBefore(moment.utc(start), granularity);
			}
		}
	}

	return result;
};

export const filterAccounts = (input, searchValue) => {
	if (!Array.isArray(input) || input.length === 0 || !input[0].AccountNumber || !searchValue) {
		return input;
	}

	const maskExpr = /\?/.test(searchValue) ? new RegExp(`\\b${searchValue.replace(/\./g, '').replace(/_/g, '?').replace(/\?/g, '[0-9]')}`) : null;

	const output = [];

	for (const item of input) {
		let isMatch;

		if (maskExpr === null) {
			isMatch = item.AccountNumber.includes(searchValue) || item.Description.toLowerCase().includes(searchValue.toLowerCase());
		} else {
			isMatch = maskExpr.test(item.AccountNumber.replace(/\./g, ''));
		}

		if (isMatch) {
			output.push(item);
		}
	}

	return output;
};
